<template>
  <div class="loanApplicationPage" v-if="!showLoad">
    <div class="wrap">
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.applicantIdName"
          v-if="mode != 'add'"
          readonly
          label="申请人："
          class="ggInput"
        />
        <van-field
          v-model="userinfo.realName"
          clearable
          readonly
          v-else
          class="ggInput"
          input-align="right"
          label="申请人："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field
          v-model="propertyData.amount"
          class="ggInput"
          input-align="right"
          :readonly="!editType"
          clearable
          :required="editType"
          type="number"
          v-enterIntNumber
          label="申请金额（元）："
          placeholder="请输入...  "
        />
      </van-cell-group>
      <van-cell-group
        class="baseNone baseSalary"
        v-if="propertyData.paymentTypeName != null"
      >
        <van-field
          :required="editType"
          v-model="propertyData.paymentTypeName"
          placeholder="请选择"
          @click="showPaymentType"
          readonly
          :is-link="editType"
          class="ggInput"
          label="付款方式："
        />
      </van-cell-group>
      <van-cell-group
        class="baseNone baseSalary"
        v-if="
          propertyData.paymentType == 'zz' && propertyData.bankAccount != null
        "
      >
        <van-field
          :required="editType"
          v-model="propertyData.bankAccount"
          placeholder="请输入...  "
          :readonly="!editType"
          class="ggInput"
          label="开户银行："
        />
      </van-cell-group>
      <van-cell-group
        class="baseNone baseSalary"
        v-if="
          propertyData.paymentType == 'zz' && propertyData.depositBank != null
        "
      >
        <van-field
          :required="editType"
          v-model="propertyData.depositBank"
          placeholder="请输入...  "
          :readonly="!editType"
          class="ggInput"
          label="银行账户："
        />
      </van-cell-group>
      <!-- 所属项目 -->
      <van-cell-group
        class="itemSite baseNone beizhu"
        v-if="projectName != null"
      >
        <van-field
          v-model="projectName"
          required
          type="textarea"
          label="所属项目："
          placeholder="请选择"
          @click="showItemPickerFun"
          readonly
          input-align="right"
          rows="1"
          :is-link="editType"
          autosize
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.purpose"
          class="ggInput"
          input-align="right"
          :readonly="!editType"
          clearable
          rows="1"
          autosize
          type="textarea"
          :required="editType"
          label="借款用途："
          placeholder="请输入...  "
        />
      </van-cell-group>
      <!-- 附件 -->
      <!-- 微信的附件 避免和原生交互 -->
      <wx-file-view
        v-if="is_weixn"
        :filesData="propertyData"
        :editType="editType"
        class="fileview"
      ></wx-file-view>
      <!-- 原生附件 -->
      <file-view
        v-else
        :filesData="propertyData"
        :editType="editType"
        @changeFile="changebaseAnnexes"
        class="fileview"
      ></file-view>

      <!-- 审批流程 -->
      <div
        class="approveList"
        v-if="this.mode != 'add' && propertyData.verifyStatus != 'hold'"
      >
        <audit-list :applicantData="propertyData"></audit-list>
      </div>

      <!-- 流程图 -->
      <div
        class="flowList"
        v-if="this.mode != 'add' && propertyData.verifyStatus != 'hold'"
      >
        <flow-staff :applicantData="propertyData"></flow-staff>
        <flow-list :workflowCode="propertyData.workflowCode"></flow-list>
      </div>
      <!-- 审批 -->
      <van-popup
        v-model="verifyPageType"
        closeable
        round
        close-icon="close"
        position="bottom"
        class="verifyPage"
      >
        <verify-main :applicantData="propertyData" @changeVerifyType="setVerifyType"></verify-main>
      </van-popup>
    </div>
    <!-- 保存按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput"
        class="btn"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="propertyData.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
              class="btn"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput"
              class="btn"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="propertyData.verifyStatus == 'deny'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput"
          class="btn"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        propertyData.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply"
        class="btn"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          propertyData.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          propertyData.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">{{
        verifyPageText
      }}</van-button>
    </div>
    <refresh-page v-if="refreshPage" />
    <!-- 弹出框 -->
    <!-- 项目管理 -->
    <van-popup v-model="showItemPicker" position="bottom" class="roleBox">
      <project-view @setItems="setProject"></project-view>
    </van-popup>
    <!-- 付款方式 -->
    <van-popup v-model="showPaymentTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="showPaymentTypeList"
        value-key="dictName"
        @cancel="showPaymentTypePicker = false"
        @confirm="savePaymentLevel"
      />
    </van-popup>
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
const projectView = () => import("@/components/businessTripMould/projectView");
const refreshPage = () => import("@/components/common/refreshPage");
const fileView = () => import("@/components/common/fileView");
const wxFileView = () => import("@/components/common/wxFileView");
const flowList = () => import("@/components/common/flowList");
const auditList = () => import("@/components/common/auditList");
const flowStaff = () => import("@/components/common/flowStaff");
const verifyMain = () => import("@/components/common/verifyMain");
import { dateFormat, isEdit } from "@/utils/common";
import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
export default {
  name: "loanApplication",
  data() {
    return {
      propertyData: {
        applicantIdName: "", //名称
        projectId: "", //所属项目code
        amount: "", //借款金额
        purpose: "", //借款用途
        bankAccount: "", //开户银行

        depositBank: "", // 银行账号
        paymentTypeName: "", //付款方式name
        paymentType: "", //付款方式code
        verifyStatus: "hold",
        baseAnnexes: [], //附件
      },
      projectName: "", //所属项目名称
      commonId: "",
      mode: "add",
      editType: false,
      refreshPage: false, // 网络请求失败时显示
      clientType: getDeviceType(), //手机类型
      addType: false, //防止高频点击
      showItemPicker: false,
      showPaymentTypePicker: false, //转账方式弹框
      showPaymentTypeList: [
        {
          dictName: "转账",
          dictCode: "zz",
        },
        {
          dictName: "现金",
          dictCode: "xj",
        },
        {
          dictName: "汇票",
          dictCode: "hp",
        },
        {
          dictName: "保函",
          dictCode: "bh",
        },
      ], //转账方式列表
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      sendType: "", //判断是否在抄送列表
      is_weixn: is_wei(), //是否为微信
    };
  },
  mounted() {
     if(is_wei()){
      document.title="借款申请";
    }
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.editType = this.mode == "add" ? true : false;
    window.editPage = this.editPage; //编辑页面

    this.$nextTick(() => {
      this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
      if (this.mode == "add") {
        this.setShowLoad(false);
      } else {
        this.initPage();
      }
    });
  },
  components: {
    projectView,
    refreshPage,
    fileView,
    wxFileView,
    auditList,
    flowList,
    verifyMain,
    flowStaff,
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    editPage() {
      //需要编辑
      this.editType = true;
    },
    //监测附件方法
    changebaseAnnexes(data) {
      this.propertyData.baseAnnexes = data;
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    verifyPage() {
      //审批弹窗
      this.verifyPageType = true;
    },
    setProject(data) {
      //获取所属项目
      if (data != "") {
        this.propertyData.projectId = data.id;
        this.projectName = data.name;
      }
      this.showItemPicker = false;
    },
    showItemPickerFun() {
      if (this.editType) {
        this.showItemPicker = true;
      }
    },
    showPaymentType() {
      //判断当前是否编辑状态
      if (this.editType) {
        this.showPaymentTypePicker = true;
      }
    },
    savePaymentLevel(data) {
      this.showPaymentTypePicker = false;
      this.propertyData.paymentTypeName = data.dictName;
      this.propertyData.paymentType = data.dictCode;
    },
    initPage() {
      this.setShowLoad(false);
      let _this = this;
      _this.$api.finance.borrow
        .detail(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.propertyData = newApi.assign(
              {},
              _this.propertyData,
              res.data
            );
            _this.projectName = res.data.projectName;
            _this.propertyData.paymentTypeName =
              res.data.paymentType == "zz" ? "转账" : res.data.paymentType == "xj"?"现金":
              res.data.paymentType == "hp"
                ? "汇票":"保函";
            if (
              (_this.propertyData.verifyStatus == "hold" &&
                _this.mode == "edit") ||
              (_this.propertyData.verifyStatus == "deny" &&
                _this.mode == "edit")
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    // 撤回和删除
    delApply() {
      let _this = this;
      let text = this.propertyData.verifyStatus == "hold" ? "删除" : "撤回";
      this.$dialog
        .alert({
          title: text,
          message: "你确定" + text + "吗?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.finance.borrow
            .deleteRecall(this.propertyData.verifyStatus, _this.propertyData.id)
            .then((res) => {
              if (res.code == "1") {
                let msg = text + "成功";
                closePage(msg);
              } else {
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              console.log(err);
              _this.btnLoading = false;
              _this.$toast("网络失败，请稍后重试");
            });
        });
    },
    //保存
    checkInput() {
      let _this = this;
      if (this.validate()) {
        let params = this.propertyData;
        _this.btnLoading = true;
        _this.$api.finance.borrow
          .update(this.mode, params)
          .then((res) => {
            if (res.code == "1") {
              let msg = this.mode == "add" ? "添加成功" : "编辑成功";
              closePage(msg);
            } else {
              _this.$toast(res.msg);
            }
            _this.btnLoading = false;
          })
          .catch((err) => {
            console.log(err);
            _this.btnLoading = false;
            _this.$toast("网络失败，请稍后重试");
          });
      }
    },
    validate() {
      let _this = this;
      console.log("1111====" + this.propertyData);
      if (this.propertyData.paymentType == "xj") {
        if (
          this.propertyData.amount == "" ||
          this.propertyData.projectId == "" ||
          this.propertyData.paymentType == "" ||
          this.propertyData.purpose == ""
        ) {
          _this.$toast("请完善表单信息");
          return false;
        }
      } else {
        if (
          this.propertyData.amount == "" ||
          this.propertyData.projectId == "" ||
          this.propertyData.purpose == "" ||
          this.propertyData.bankAccount == "" ||
          this.propertyData.depositBank == "" ||
          this.propertyData.paymentType == ""
        ) {
          _this.$toast("请完善表单信息");
          return false;
        }
      }

      return true;
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
<style lang="less">
.loanApplicationPage {
  width: 100%;
  min-height: 100%;
  background-color: #f6f6f6;
  .dwBox {
    .van-cell {
      .van-cell__title {
        width: 150px;
      }
    }
  }
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 15px;
    // overflow-y: initial;
  }
  #searchHeight {
    text-align: left;
  }
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }

  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin-top: 10px;
  }
}
</style>